import React from "react";
import { Box } from "@mui/material";
import Backup from "./backup/Backup";
import Gst from "./backup/Gst";

const Setting = () => {
  return (
    <>
      <Box
        sx={{ width: "100%", p: { xs: 2, md: 3 }, backgroundColor: "#f7f8fa" }}
      >
        {/* <Backup /> */}
        <Gst />
      </Box>
    </>
  );
};

export default Setting;
